import {
    GET_TICKETS,
    SAVE_TICKETS,
    RESET_TICKETS
  } from '../constants/tickets';

const initState = {
	tickets: {
        count: 0,
        data: []
    },
    loading: {
        tickets: false,
        bulkAssign: false
    }
}

const tickets = (state = initState, action) => {
	switch (action.type) {
		case GET_TICKETS: {
            console.log("YAHAH SE NIKLA");
			return {
				...state,
                loading: {
                    ...state.loading,
                    tickets: true
                }
			}
		}
        case SAVE_TICKETS: {
            console.log("YAHAH SE NIKLA 2");
			return {
				...state,
				tickets: {...action.payload},
                loading: {
                    ...state.loading,
                    tickets: false
                }
			}
		}
		case RESET_TICKETS: {
			return{
				tickets: {
                    count: 0,
                    data: []
                },
                loading: {
                    tickets: false,
                    bulkAssign: false
                }
			}
		}
		default:
			return state;
	}
}

export default tickets;